import React, { useEffect, useState } from 'react';
import Icon from '@lwt-helix/icon';
import PropTypes from 'prop-types';

const ColumnHeader = (props) => {
    const {
        api,
        column,
        isKeyInfoTable,
        setSort,
        enableSorting,
        titleWithTooltip
    } = props;

    const [state, setState] = useState({
        ascSort: column.colDef?.sort === 'asc' ? 'd-block' : 'd-none',
        descSort: column.colDef?.sort === 'desc' ? 'd-block' : 'd-none',
        isSortDescending: column.colDef?.sort === 'desc'
    });

    const onSortChanged = (event) => {
        const api = event.api;
        if (api.columnModel.displayedColumns) {
            const ownSortedColumn = api.columnModel.displayedColumns
                .filter(item => item.sort && item.sortIndex === 0)
                .find(item => item.colId === column.colId);
            setState({
                ascSort: ownSortedColumn?.sort === 'asc' ? 'd-block' : 'd-none',
                descSort: ownSortedColumn?.sort === 'desc' ? 'd-block' : 'd-none',
                isSortDescending: ownSortedColumn?.sort === 'desc'
            });
        }
    };

    const onBodyScroll = (e) => {
        const sortedCol = e.api.columnModel?.displayedColumns.filter(item => item.sort);
        if (sortedCol && sortedCol.length > 0 && column.colId === sortedCol[0]?.colId) {
            setState({
                ascSort: sortedCol[0].sort === 'asc' ? 'd-block' : 'd-none',
                descSort: sortedCol[0].sort === 'asc' ? 'd-none' : 'd-block',
                isSortDescending: !(sortedCol[0].sort === 'asc')
            });
        } else {
            setState({
                ascSort: 'd-none',
                descSort: 'd-none',
                isSortDescending: false
            });
        }
    };

    useEffect(() => {
        let isMounted = true;

        const handleSortChanged = (event) => {
            if (isMounted) onSortChanged(event);
        };

        const handleBodyScroll = (event) => {
            if (isMounted) onBodyScroll(event);
        };

        column.addEventListener('sortChanged', handleSortChanged);
        api.addEventListener('bodyScroll', handleBodyScroll);

        return () => {
            isMounted = false;
            if (column && !column.isDestroyed?.()) {
                column.removeEventListener('sortChanged', handleSortChanged);
            }
            if (api && !api.isDestroyed?.()) {
                api.removeEventListener('bodyScroll', handleBodyScroll);
            }
        };
    }, [api, column]);

    const handleSort = (event) => {
        const nextSort = state.isSortDescending ? 'asc' : 'desc';
        setSort(nextSort, event.shiftKey);
        const isPrimarySort = (column.getSortIndex() ?? 0) === 0;
        setState({
            ascSort: isPrimarySort && nextSort === 'asc' ? 'd-block' : 'd-none',
            descSort: isPrimarySort && nextSort === 'desc' ? 'd-block' : 'd-none',
            isSortDescending: nextSort === 'desc'
        });
    };

    let sort = null;
    if (enableSorting) {
        sort = (
            <div className='d-inline-block'>
                <div className={`div_arrow_drop_down ${state.descSort}`}>
                    <Icon dataLwtId='icon' iconName='arrow_drop_down' />
                </div>
                <div className={`div_arrow_drop_up ${state.ascSort}`}>
                    <Icon dataLwtId='icon' iconName='arrow_drop_up' />
                </div>
            </div>
        );
    }

    return (
        <div
            className={'w-100 ag-header-cell-text d-inline-block ag-header-col-text'}
            onClick={event => handleSort(event)}
        >
            {titleWithTooltip}
            {!isKeyInfoTable && sort}
        </div>
    );
};

ColumnHeader.propTypes = {
    api: PropTypes.object,
    column: PropTypes.object,
    enableSorting: PropTypes.bool,
    isKeyInfoTable: PropTypes.bool,
    setSort: PropTypes.func,
    titleWithTooltip: PropTypes.object
};

export default ColumnHeader;
